export enum StatusComplaintsEnum {
  NEW = "NEW",
  DISPUTE_CALL_CENTER = "DISPUTE_CALL_CENTER",
  CALL_CENTER = "CALL_CENTER",
  TRAFFIC = "TRAFFIC",
  CONSIDERATION = "CONSIDERATION"
}